import React, { useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../../../contexts/AuthContext";
import Request from "../../../../services/api/Request";

import Alert from "../Alert";
import "./assets/user-menu.css";
import ImgPlaceholder from "./assets/images/placeholder.svg";

const UserMenu: React.FC = () => {
  const { user, logged, Logout } = useContext(AuthContext);
  Request.OnLogout = Logout;

  function menuToggle() {
    const userMenu = document.querySelector(".user");
    if (userMenu != null) userMenu.classList.toggle("user--open");
  }

  const UserNode = () => {
    const mystyles = {
      background: `url(${user!.picture || ImgPlaceholder})`
    } as React.CSSProperties;

    return (
      <React.Fragment>
        <div className="loggedIn">
          <Alert />
          <div className="user">
            <div onClick={menuToggle} className="user__info">
              <div className="user__pic" style={mystyles}>
                {/* <img className="user__pic" src={user!.picture || ImgPlaceholder} alt={user!.name} /> */}
              </div>
              <span className="user__name">{user!.name}</span>
            </div>

            <nav className="user__menu">
              <ul className="user__list">
                <li>
                  <Link className="user__list--item" to="/profile">
                    My Profile
                  </Link>
                </li>
                <li>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      Logout(true);
                    }}
                    className="user__list--item"
                    href="/logout"
                  >
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  };

  return <React.Fragment>{logged && <UserNode />}</React.Fragment>;
};
export default UserMenu;
